<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card class="review-for-examinee">
    <v-subheader>
      <v-icon medium color="success" class="mr-2">people</v-icon>
      {{date}} <span class="ml-2">Ревью в качестве проверяемого <span v-if="deleted" class="error--text">DELETED</span></span>
    </v-subheader>
    <v-layout row>
      <v-flex xs4>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Ревьювер: </span>
            <UserCard :user="reviewer"></UserCard>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs3>
        <v-card tile flat class="grey lighten-3">
          <v-card-text>
            <span class="font-weight-medium">Уровень ревьювера: </span>{{reviewerLevel}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Скачать код: </span>
            <span v-for="(homework, index) in homeworks" :href="homework">
              <a :href="homework">#{{index + 1}}</a>
              <span v-if="index < homeworks.length -1 ">, </span>
            </span>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="review-table">
      <table>
        <tr class="review-table__head">
          <th>Задание</th>
          <th>Оценка</th>
          <th>Комментарий</th>
        </tr>
        <tbody v-for="(review, index) in marks">
        <tr class="review-table__subhead"><td colspan="3">Ревью {{index}}</td></tr>
        <tr v-for="task in review" v-if="!task.deleted">
          <td class="review-table__col--task-number">{{task.taskNumber}}</td>
          <td class="review-table__col--mark">
            <span :class="getMarkClass(task.mark)">
              <strong>{{task.mark}}</strong>
            </span>
          </td>
          <td>{{task.comment}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <v-layout row>
      <v-flex xs6>
        <v-card tile flat class="grey lighten-3">
          <v-card-text>
            <span class="font-weight-medium">Фидбек от проверяемого:</span> {{feedbackFromExaminee.comment}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs3 class="grey lighten-4">
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Длительность ревью:</span> {{durationFromExaminee}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs3 class="grey lighten-3">
        <v-card tile flat class="grey lighten-3">
          <v-layout row align-center class="mt-2 ml-3">
            <span class="font-weight-medium">Оценка: </span>
            <v-rating
              readonly
              v-model="feedbackFromExaminee.mark"
              small
              :color="getRatingColor(feedbackFromExaminee.mark)"
              background-color="secondary"
            ></v-rating>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs6>
        <v-card tile flat class="grey lighten-4">
          <v-card-text>
            <span class="font-weight-medium">Фидбек от ревьювера:</span> {{feedbackFromReviewer.comment}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs3 class="grey lighten-3">
        <v-card tile flat class="grey lighten-3">
          <v-card-text>
            <span class="font-weight-medium">Длительность ревью:</span> {{durationFromReviewer}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs3 class="grey lighten-4">
        <v-card tile flat class="grey lighten-4">
          <v-layout row align-center class="mt-2 ml-3">
            <span class="font-weight-medium">Оценка: </span>
            <v-rating
              readonly
              v-model="feedbackFromReviewer.mark"
              :color="getRatingColor(feedbackFromReviewer.mark)"
              background-color="secondary"
              small
            ></v-rating>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  import UserCard from "../user/UserCard";
  export default {
    name: "ReviewForExaminee",
    components: {UserCard},
    props: [
      "date",
      "description",
      "reviewer",
      "reviewerLevel",
      "homeworks",
      "marks",
      "feedbackFromReviewer",
      "feedbackFromExaminee",
      "durationFromReviewer",
      "durationFromExaminee",
      "deleted"
    ],
    methods: {
      getRatingColor(mark) {
        if (mark >= 4) {
          return "success"
        }

        if (mark === 3) {
          return "warning"
        }

        if (mark < 3) {
          return "error"
        }
      },

      getMarkClass(mark) {
        if (mark >= 4) {
          return "green--text"
        }

        if (mark === 3) {
          return "orange--text"
        }

        if (mark < 3) {
          return "red--text"
        }
      }
    }
  }
</script>

<style scoped>
  .review-for-examinee {
    border: 1px solid #78909C;
  }

  .review-table {
    display: flex;
    justify-content: center;
  }

  .review-table table {
    border-collapse: collapse;
    width: 100%;
    margin: 10px;
  }

  .review-table__head {
    text-align: center;
  }

  .review-table__subhead {
    background-color: #eee;
    text-align: center;
    padding: 10px;
  }

  .review-table__col--task-number,
  .review-table__col--mark {
    width: 10%;
    text-align: center;
  }

  .review-table td, th {
    border: 1px solid #dddddd;
    padding: 10px;
  }
</style>
